<template>
  <a-entity rotation="-90 0 0" position="0 0 0">
    <a-gltf-model
      src="#terrain"
      ref="model"
      @model-loaded="loaded"
      rotation="-90 180 0"
      position="0 0 .2"
    />
  </a-entity>
</template>

<script>
export default {
  name: 'Terrain',
  methods: {
    setColor() {
      // const color = new THREE.Color(this.currentLevel.color)
      // _.each(this.$materials, m => m.set(color))
    },
    loaded(e) {
      return
      const model = this.$refs.model.object3D

      const meshs = []
      this.$materials = []

      model.traverse( child => {
        if(child.material)
          meshs.push(child)
      })

      _.each(meshs, m => {
        if(m.material.name == 'MAT_spotlight')
          this.$materials.push(m.material.color)
      })

      this.setColor()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/terrain/Terrain.vue